import { useMemo } from 'react';
import { useResourceUserDetailsContext } from '~/modules/resource-management/resourceUserDetails/ResourceUserDetailsContext';

export const useGlobalNudgeActions = () => {
  const {
    state: { globalNudges }
  } = useResourceUserDetailsContext();

  const {
    hasAcceptCallbacks,
    hasRejectCallbacks,
    onAcceptAllNudges,
    onRejectAllNudges
  } = useMemo(() => {
    const acceptCallbacks = [];
    const rejectCallbacks = [];

    Object.values(globalNudges).forEach(nudgeType => {
      if (!nudgeType?.editable) return;

      const { onAccept, onReject } = nudgeType;

      if (onAccept) acceptCallbacks.push(onAccept);
      if (onReject) rejectCallbacks.push(onReject);
    });

    return {
      hasAcceptCallbacks: Boolean(acceptCallbacks.length),
      hasRejectCallbacks: Boolean(rejectCallbacks.length),
      onAcceptAllNudges: () => acceptCallbacks.forEach(callback => callback()),
      onRejectAllNudges: () => rejectCallbacks.forEach(callback => callback())
    };
  }, [globalNudges]);

  return {
    hasAcceptCallbacks,
    hasRejectCallbacks,
    onAcceptAllNudges,
    onRejectAllNudges
  };
};

export default useGlobalNudgeActions;
